export const PHONE_NUMBER_DATA_TEST = {
  MAIN: 'phone-number.main.test-id',
};
